import React from 'react';
import { Trophy } from 'lucide-react';

// Always-visible prize-draw notice for the Leave a Review page, shown directly
// above the submit button. It replaces the one-shot pop-up, which disappeared
// for good once a visitor dismissed it — this card is seen on every visit.
export default function ReviewDrawCard() {
  return (
    <div className="border border-primary/25 bg-primary/[0.06] p-5">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 shrink-0 border border-primary/40 bg-primary/15 flex items-center justify-center">
          <Trophy className="w-4 h-4 text-primary" />
        </div>
        <div>
          <p className="text-primary text-[10px] font-bold tracking-widest mb-1">MONTHLY PRIZE DRAW</p>
          <p className="text-white font-bold text-sm uppercase tracking-wide mb-1.5">Review &amp; Win</p>
          <p className="text-white/40 text-xs leading-relaxed">
            Paste a link to the same review on Google or Trustpilot to be entered into our free monthly draw — one
            entry per verified link. Winners are drawn at random and contacted by email.
          </p>
        </div>
      </div>
    </div>
  );
}